export const toMoneyString = (value, prefix = 'R') => {
    if (value == null) return '';
    if (typeof value === 'number') return `${prefix}${value.toFixed(2)}`;
    return String(value);
};

export const parseMoney = (v) => {
    if (v == null) return 0;
    if (typeof v === 'string') {
        const cleaned = v.replace(/^[^0-9.-]*/, '');
        const n = parseFloat(cleaned);
        return Number.isFinite(n) ? n : 0;
    }
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
};

export const calculatePricing = (scriptData, dispensingFee) => {
    // Gross: apply PR / PR26 pricing rules from original cashpricingoption
    // (mirrors ScriptHistoryDetails), then add dispensing fee.
    const st = (scriptData?.scriptType || 'PR').toUpperCase();
    // SEP-regulated medicine pricing is fixed by law for medical-aid claims — a
    // pharmacy can only add the regulated dispensing fee, not a retail markup.
    // These PR/PR26 rules are cash-retail pricing and must never apply here.
    const isMedicalAid = scriptData?.paymentType === 'Medical Aid';

    const pricedSum = Array.isArray(scriptData?.drugs)
        ? scriptData.drugs.reduce((sum, d) => {
            const cp = parseMoney(d.costPrice);
            const qty = parseFloat(d.quantity ?? d.qty) || 0;
            if (!Number.isFinite(cp) || cp <= 0 || qty <= 0) return sum;
            const base = cp * qty;
            if (isMedicalAid) return sum + base;
            if (st === 'PR') return sum + base * 1.34;
            if (st === 'PR26') {
                if (base < 100) return sum + (base + 26);
                return sum + base * 1.26;
            }
            // For PRT or any other option, fall back to base (no extra markup)
            return sum + base;
        }, 0)
        : 0;

    // Prefer the live branch dispensing fee; fall back to whatever was
    // persisted on the script, if present.
    const dispensingFeeValue = Number.isFinite(dispensingFee) && dispensingFee > 0
        ? dispensingFee
        : parseMoney(scriptData?.dispensingFee);

    const grossWithDispensing = pricedSum + (Number.isFinite(dispensingFeeValue) ? dispensingFeeValue : 0);

    const grossAmount = Number.isFinite(grossWithDispensing) && grossWithDispensing > 0
        ? grossWithDispensing.toFixed(2)
        : '';

    return { dispensingFeeValue, grossWithDispensing, grossAmount };
};

export const buildPrescription = (scriptData, companyName, pharmacyRegNumber, grossAmount) => ({
    title: 'CERTIFIED COPY OF DOCTORS PRESCRIPTION',
    lines: Array.isArray(scriptData?.drugs)
        ? scriptData.drugs.map((d) => ({
            code: d.nappiCode || d.code || '',
            drug: d.drugName || '',
            qty: String(d.quantity ?? d.qty ?? ''),
            side: d.side || '',
            icd10: d.icd10 || '',
            price: toMoneyString(d.costPrice, 'R '),
            instructions: d.instructions ? [d.instructions] : [],
        }))
        : [],
    pharmacy: companyName || scriptData?.pharmacy || '',
    registration: pharmacyRegNumber || scriptData?.pharmacyRegistration || '',
    copyCost: scriptData?.copyCost ? toMoneyString(scriptData.copyCost, 'R ') : '',
    total: grossAmount ? `R ${grossAmount}` : (scriptData?.total ? toMoneyString(scriptData.total, 'R') : ''),
});
